module.exports = __webpack_public_path__ + "images/formas-pagamento---57dc11129d7937ebd7d0c324261b7f73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/footer/img/formas-pagamento.jpg
// module id = 382
// module chunks = 0